import api from "../../helpers/api";

export const getTrainingCenters = (body) => api.post(`training-center/search/`, {...body});

export const createTrainingCenter = (body) =>
	api.post(`training-center/`, { ...body });


export const updateTrainingCenter = (id,body) => api.put(`training-center/${id}`, {...body})

export const getSingleTrainingCenter = (id) => api.get(`/training-center/${id}`)

export const deleteTrainingCenter = (id) => api.delete(`/training-center/${id}`)

export const switchTrainingCenter = (id,body) => api.put(`/training-center/${id}`, {...body})

export const addTrainingCenterCourse = (body) => api.post(`training-center/add-course`, {...body})
export const editTrainingCenterCourse = (body) => api.post(`training-center/edit-course`, {...body})
export const deleteTrainingCenterCourse = (body) => api.post(`training-center/rem-course`, {...body})